import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { ReactComponent as Logo } from "./assets/images/Signature Homes long logo (2).svg";
import { ReactComponent as HamburgerIcon } from "./assets/icons/hamburger.svg";
import { ReactComponent as CrossIcon } from "./assets/icons/cross.svg";
import { ReactComponent as WhatsAppIcon } from "./assets/icons/whatsapp.svg";
import { trackWhatsappClick } from "../utils/analytics";

const WHATSAPP_URL = "https://wa.me/447892845043";

function Navbar({ isHeroSection, isHomePage }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFullscreenActive, setIsFullscreenActive] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = (e) => {
      setIsFullscreenActive(e.detail.isFullscreen);
    };

    window.addEventListener("fullscreenToggle", handleFullscreenChange);
    return () =>
      window.removeEventListener("fullscreenToggle", handleFullscreenChange);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav
      className={`navbar ${
        isHomePage
          ? isHeroSection
            ? "navbar-on-hero"
            : "navbar-scrolled"
          : "navbar-static"
      } ${isFullscreenActive ? "fullscreen-active" : ""}`}
    >
      <div className="navbar-container">
        {/* Hamburger Icon */}
        <button
          className={`hamburger ${isMenuOpen ? "menu-open" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <CrossIcon /> : <HamburgerIcon />}
        </button>

        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/" onClick={closeMenu}>
            <Logo />
          </Link>
        </div>

        <div className="navbar-actions">
          <a
            href={WHATSAPP_URL}
            className="whatsapp-link"
            aria-label="WhatsApp"
            target="_blank"
            rel="noreferrer"
            onClick={() => trackWhatsappClick(WHATSAPP_URL)}
          >
            <WhatsAppIcon />
          </a>
          <Link
            to="/contact-us"
            className="enquire-btn"
            onClick={closeMenu}
            aria-label="Enquire now"
            id="nav-enquire-btn"
          >
            <span className="enquire-text-full">Enquire now</span>
            <span className="enquire-text-short">Enquire</span>
          </Link>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
        <ul className="navbar-menu">
          <li>
            <Link to="/" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/properties/al-majdieh-village-villas" onClick={closeMenu}>
              Villas - Meshraf al-Majdiah
            </Link>
          </li>
          <li>
            <Link to="/properties/al-majdieh-village-apartments" onClick={closeMenu}>
              Apartments - Meshraf al-Majdiah
            </Link>
          </li>
          <li>
            <Link to="/payment-plan" onClick={closeMenu}>
              Payment Plan
            </Link>
          </li>
          <li>
            <Link to="/about-developer" onClick={closeMenu}>
              About the developer
            </Link>
          </li>
          <li>
            <Link to="/about-us" onClick={closeMenu}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/faq" onClick={closeMenu}>
              FAQ
            </Link>
          </li>
          <li>
            <Link to="/contact-us" onClick={closeMenu}>
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
